import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/rest/user/login.do',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/rest/user/info.do',
    method: 'get',
    params: { }
  })
}

export function logout() {
  return request({
    url: '/rest/user/logout.do',
    method: 'post'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/rest/platform/account/changePassword.do',
    method: 'post',
    data: data
  })
}


export function getBranchInfo(data) {
  return request({
      url: '/branchInfoTree/getBranchInfo.do',
      method: 'post',
      data: data
  })
}

export function Ukey(data) {
  return request({
    url: '/Ukey/login.do',
    method: 'GET',
    params: {
      id: data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js